import "./Home.module.css";
import Navigation from "@/reusable_sections/Header";
import Vision from "./sections/Vision";
import Standard from "./sections/Standard";
import Expertise from "./sections/Expertise";
import Trust from "./sections/Trust";
import Testimonials from "./sections/Testimonials";
import Project from "./sections/Project";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Navigation />
      <Vision />
      <Standard />
      <Expertise />
      <Trust />
      <Testimonials />
      <Project />
      <Footer />
    </div>;
}